<template>
    <div class="wrapper">
        <h2>Impressum</h2>
        <p>
            <span>Ad Alliance GmbH</span><br>
            <span>Picassoplatz 1</span><br>
            <span>50679 Köln</span>
        </p>
        <p>
            <span>Geschäftsführer: Matthias Dang, Stephan Schäfer</span>
        </p>
        <p>
            <span>Registriert beim Amtsgericht Köln, HRB 54060</span><br>
            <span>USt-Id: DE 209 654 336</span>
        </p>
        <p>
            <span>Inhaltlich verantwortlich gemäß § 55 Absatz 2 RStV</span><br>
            <span>Matthias Dang</span><br>
            <span>Ad Alliance GmbH</span><br>
            <span>Picassoplatz 1</span><br>
            <span>50679 Köln</span><br>
            <span>Telefon: +49 221 456-20</span><br>
            <span>Fax: +49 221 456-26999</span>
        </p>
    </div>
</template>

<script>

    export default {
        name: "Impressum"
    }
</script>

<style scoped>
    @media only screen and (max-width: 1200px) {
        .wrapper {
            padding: 1rem;
        }
    }
</style>